import { defineComponent as _defineComponent } from 'vue'
import { useMQ } from '@/js/lib/helper/media-query';
import { NativeView, urlForDeepLink } from '@/js/lib/helper/yappli';
import IModal from '@/js/components/molecules/IModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailConfirmedModal',
  props: {
    fromNative: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {



const { isSp } = useMQ();
const onTapToGoBackToApp = () => {
  window.location.href = urlForDeepLink(NativeView.HOME);
};
const modalClose = () => {
  emit('close');
};

return { __sfc: true,emit, isSp, onTapToGoBackToApp, modalClose, IModal }
}

})